












import { Vue, Prop, Component } from 'vue-property-decorator';
import { BaseDropdown } from '../base-dropdown';
import { BaseInputBox } from '../base-input-box';
import { BaseColorPicker } from '.';

@Component({
  name: 'BaseColorPickerInput',
  components: {
    BaseDropdown,
    BaseInputBox,
    BaseColorPicker,
  },
})
export default class BaseColorPickerInput extends Vue {
  @Prop({ default: '#fe9500' }) color: string;
  @Prop() label: string;

  handleUpdate(color: string) {
    this.$emit('update', color);
  }
}
